import { supabase } from "../../../app/supabaseClient";
import supabaseApi from "../supabaseSlice";

const amenitiesApi = supabaseApi.injectEndpoints({
  endpoints: (build) => ({
    getAmenities: build.query({
      queryFn: async () => {
        const { data, error } = await supabase
          .from("amenities")
          .select("*")
          .order("order");
        if (error) throw { error };
        return { data };
      },
    }),
  }),
});

export const { useGetAmenitiesQuery, useLazyGetAmenitiesQuery } = amenitiesApi;
